import { BrandLogo, WHATSAPP_URL, PHONE_TEL, PHONE_DISPLAY } from "./shared";
import { ShieldCheck, Award, FileCheck, Instagram } from "lucide-react";

const QUICK_LINKS = [
  { label: "Serviços", href: "#servicos" },
  { label: "Como Funciona", href: "#protocolo" },
  { label: "Por que Nós", href: "#diferenciais" },
  { label: "Loja & Horários", href: "#unidade" },
  { label: "Avaliações", href: "#avaliacoes" },
];

const BADGES = [
  { icon: ShieldCheck, label: "Dados protegidos" },
  { icon: Award, label: "Garantia documentada" },
  { icon: FileCheck, label: "Orçamento com fotos" },
];

export default function Footer() {
  return (
    <footer className="bg-[#1D2328] border-t border-white/10 pt-16 pb-10 px-4 sm:px-8">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10">
        <div>
          <BrandLogo />
          <p className="mt-4 text-sm leading-relaxed text-zinc-400 max-w-xs">
            Assistência técnica de celulares no Rio Branco, São Leopoldo. Cuidado de verdade
            com o aparelho mais importante do seu dia.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {BADGES.map((b) => (
              <span
                key={b.label}
                className="inline-flex items-center gap-1.5 font-mono-tech text-[10px] tracking-wider uppercase text-zinc-300 border border-white/10 rounded-full px-3 py-1.5"
              >
                <b.icon size={12} className="text-[#99BA4B]" />
                {b.label}
              </span>
            ))}
          </div>
        </div>

        <div>
          <h3 className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-zinc-400 mb-4">
            Navegação
          </h3>
          <ul className="space-y-2.5">
            {QUICK_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="text-sm text-zinc-300 hover:text-[#ADCF5D] transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-zinc-400 mb-4">
            Contato Direto
          </h3>
          <ul className="space-y-2.5 text-sm text-zinc-300">
            <li>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#ADCF5D] transition-colors"
              >
                WhatsApp: {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a href={PHONE_TEL} className="hover:text-[#ADCF5D] transition-colors">
                Telefone: {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/pressicelulares/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="inline-flex items-center gap-2 hover:text-[#ADCF5D] transition-colors"
              >
                <Instagram size={15} className="text-[#99BA4B]" />
                Instagram: @pressicelulares
              </a>
            </li>
            <li>Av. São Borja, 412 — Rio Branco, São Leopoldo — RS</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-mono-tech text-[11px] text-zinc-500">
          © {new Date().getFullYear()} PRESSI CELULARES. Todos os direitos reservados.
        </p>
        <p className="font-mono-tech text-[11px] text-zinc-500">
          FEITO COM CUIDADO EM SÃO LEOPOLDO • RS
        </p>
      </div>
    </footer>
  );
}
